import type { ComponentProps } from 'react'

import type { TagProps } from '@fourthwall/components'
import type { AppsView } from '@modules/Dashboard/pages/Apps/AppsView'

import type { AppStatus, TextAppStatus } from '../Apps.types'

export const mapStatusToTagProps = (
  status: AppStatus,
  showNotConnected: boolean = true,
): ComponentProps<typeof AppsView>['apps'][number]['tag'] => {
  if (!status) return

  if (!showNotConnected && status === 'NOT_CONNECTED') return

  if (status === 'EXTERNAL') return

  const tagProps = {
    COMING_SOON: { label: 'Coming soon', appearance: 'alert' },
    CONFIGURED: { label: 'Configured', appearance: 'success' },
    CONNECTED: { label: 'Connected', appearance: 'success' },
    CONNECTING_IN_PROGRESS: { label: 'Pending', appearance: 'alert' },
    DISCONNECTING_IN_PROGRESS: { label: 'Disconnecting', appearance: 'alert' },
    IN_PROGRESS: { label: 'In progress', appearance: 'alert' },
    NOT_CONFIGURED: { label: 'Requires setup', appearance: 'alert' },
    NOT_CONNECTED: { label: 'Not connected', appearance: 'alert' },
    SYNCING: { label: 'Pending', appearance: 'alert' },
    BROKEN: { label: 'Broken', appearance: 'critical' },
  } satisfies Record<Exclude<TextAppStatus, 'EXTERNAL'>, TagProps>

  return status === true ? tagProps.CONNECTED : tagProps[status]
}
